import React, { useContext, useEffect, useState, createContext } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../firebase";
import apiUrls from "../api/apiUrls";

const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [tier, setTier] = useState(() => localStorage.getItem("user_tier") || "free");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (firebaseUser) => {
      setUser(firebaseUser);
      if (firebaseUser) {
        try {
          const token = await firebaseUser.getIdToken();
          localStorage.setItem('token', token);

          // Obtener el perfil del usuario para conocer su nivel de suscripción (tier)
          const response = await fetch(apiUrls.userProfileApi, {
            headers: {
              Authorization: `Bearer ${token}`
            }
          });
          if (response.ok) {
            const result = await response.json();
            if (result.success && result.data && result.data.tier) {
              setTier(result.data.tier);
              localStorage.setItem("user_tier", result.data.tier);
            }
          }
        } catch (err) {
          console.error("[AuthContext] Error fetching user tier:", err);
        }
      } else {
        setTier("free");
        localStorage.removeItem("user_tier");
        localStorage.removeItem("token");
      }
      setLoading(false);
    });
    return unsubscribe;
  }, []);

  return (
    <AuthContext.Provider value={{ user, tier, setTier }}>
      {!loading && children}
    </AuthContext.Provider>
  );
}
